module.exports = __webpack_public_path__ + "static/media/dots.b81dabc0.png";